import { Coolwhip } from '@circlefin/components'
import { Footer, HeaderPublic } from '@containers/layout'
import { GoogleTagManager } from '@containers/services'
import { Main } from '@shared/components/layout'
import { BaseLayout } from '@shared/layout/core'

import { RolrProgressShell } from '../../containers/RolrSignUp'
import { RolrSetupProvider } from '../../hooks/rolr/provider'

import { StepGuard } from './StepGuard'

import type { RolrSetupStepNames } from '../../hooks/rolr/context'
import type { AppLayoutType } from '@shared/layout/core'

export interface RolrSetupLayoutProps {
  /**
   * Current step name.
   */
  currentStep: RolrSetupStepNames
}

export const RolrSetupLayout: AppLayoutType<RolrSetupLayoutProps> = ({
  currentStep,
  children,
}) => {
  return (
    <RolrSetupProvider>
      <BaseLayout className="auto-rows-min grid-rows-[min-content_auto_min-content] text-neutral-subtle">
        <GoogleTagManager />
        <div>
          <HeaderPublic>
            <HeaderPublic.Logo align="left" variant="mobile-full" />
          </HeaderPublic>
          <div className="h-0.5 w-full bg-black-75" />
        </div>
        <Coolwhip
          className="fixed bottom-0 h-screen w-full translate-y-56 opacity-0 md:opacity-100"
          variant="fade-top/green-blue-violet"
        />
        <Main className="relative flex px-6 pb-12 pt-8 md:px-13 md:pt-9">
          <StepGuard currentStep={currentStep}>
            <RolrProgressShell>{children}</RolrProgressShell>
          </StepGuard>
        </Main>
        <Footer />
      </BaseLayout>
    </RolrSetupProvider>
  )
}
